




























































































































































































import { computed, defineComponent, ref } from '@vue/composition-api';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import EditButton from '@front-app/components/buttons/concrete/EditButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import ManageAccessCodesModal from '@front-app/modules/group/components/admin/securitySettings/ManageAccessCodesModal.vue';
import SecuritySettingsPanel from '@front-app/modules/group/components/admin/securitySettings/SecuritySettingsPanel.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import TrSnackbar from '@front-app/components/Snackbar.vue';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { GroupAccessMode } from '@front-app/services/GroupsApi/GroupAccessSettingsModel';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { Routes } from '@front-app/constants/routes';
import { SecuritySettingsPanelMode } from '@front-app/modules/group/components/admin/securitySettings/SecuritySettingsPanelData';
import { Spacing } from '@front-app/components/constants';
import { useAdminAccess } from '@front-app/modules/group/hooks/useAdminAccess';
import { VisibilityOption } from '@front-app/services/GroupsApi/GroupEvent';

const PREVIEW_LABELS = {
	[VisibilityOption.PUBLIC]: 'group-admin.security-settings.public-preview',
	[VisibilityOption.ALL_TIMEDRIGHT_USERS]: 'group-admin.security-settings.all-logged-in',
	[VisibilityOption.USERS_WITH_ACCESS]: 'group-admin.security-settings.only-users-access',
	[VisibilityOption.MEMBERS_ONLY]: 'group-admin.security-settings.no-preview',
};

export default defineComponent({
	components: {
		ColumnContainer,
		ColumnHeader,
		ErrorCard,
		ManageAccessCodesModal,
		SimpleCard,
		SlidingPanel,
		EditButton,
		SecuritySettingsPanel,
		TrSnackbar,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const { isCsr } = CurrentUserStore;
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const { hasSecuritySettingsAccess } = useAdminAccess(group);
		const selectedMode = ref(SecuritySettingsPanelMode.CLOSED);

		const areAnyJoinRequirementsEnabled = computed(() => {
			if (
				!group.value.accessSettings?.termsOfUse
				&& !group.value.accessSettings?.professionalsOnly
				&& !group.value.accessSettings?.enableAccessCodes
			) {
				return false;
			}
			return true;
		});

		const isManageAccessCodesPanelOpen = ref(false);

		// Copying group link
		const isCopyLinkConfirmationDisplayed = ref(false);
		const copyGroupUrl = () => {
			const route = ctx.root.$router.resolve({
				name: Routes.GROUP,
				params: {
					groupId: props.groupId,
				},
			});
			const groupUrl = new URL(route.href, window.location.href).href;
			navigator.clipboard.writeText(groupUrl);
			isCopyLinkConfirmationDisplayed.value = true;
			setTimeout(() => {
				isCopyLinkConfirmationDisplayed.value = false;
			}, 5000);
		};

		// Uploading Access Codes
		const isUploadAccessCodesConfirmationDisplayed = ref(false);
		const showUploadAccessCodesConfirmation = () => {
			isUploadAccessCodesConfirmationDisplayed.value = true;
			setTimeout(() => {
				isUploadAccessCodesConfirmationDisplayed.value = false;
			}, 5000);
		};

		return {
			GROUP_MAIN_ROUTE: Routes.GROUP_MAIN,
			group,
			selectedMode,
			SecuritySettingsPanelMode,
			hasSecuritySettingsAccess,
			areAnyJoinRequirementsEnabled,
			isManageAccessCodesPanelOpen,
			isCsr,
			GroupAccessMode,
			PREVIEW_LABELS,
			// Copying group link
			isCopyLinkConfirmationDisplayed,
			copyGroupUrl,
			// Uploading Access Codes
			isUploadAccessCodesConfirmationDisplayed,
			showUploadAccessCodesConfirmation,
			// Util
			Spacing,
		};
	},
});
